import api from "../index";

export const GetAllMaintenance = () => api.get(`Maintenance/Get-MaintenanceMode-Status`);
